// import React, { useState, useEffect } from "react";
// import { Box, Button, Grid, Typography } from "@mui/material";
// import { useWorkspace } from "../../../../contexts/WorkspaceContext";
// import sourceUrl from "../../../../api/Source.api";

// const VoiceSettings = () => {
//   const { audioVoice, setAudioVoice } = useWorkspace();
//   const [voices, setVoices] = useState([]);
//   const [selectedVoiceUrl, setSelectedVoiceUrl] = useState('');
//   const theme = localStorage.getItem('theme');
//   const token = localStorage.getItem('token');

//   const fetchVoices = async () => {
//     try {
//       const response = await fetch(`${sourceUrl}/audio/voice`, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/x-www-form-urlencoded',
//         }
//       });
//       const data = await response.json();
//       console.log('Fetched voices:', data.data.data); // Log the response for debugging
//       setVoices(data.data.data);
//       if (data.data.data.length > 0 && !audioVoice) {
//         // Set default selected voice if none is selected yet
//         setAudioVoice(data.data.data[0].name);
//         setSelectedVoiceUrl(data.data.data[0].url);
//       } else {
//         // Set the URL of the currently selected voice if reopening
//         const currentVoice = data.data.data.find(v => v.name === audioVoice);
//         if (currentVoice) {
//           setSelectedVoiceUrl(currentVoice.url);
//         }
//       }
//     } catch (error) {
//       console.error('Error fetching voices:', error);
//     }
//   };

//   useEffect(() => {
//     fetchVoices();
//   }, []);

//   const handleVoiceSelect = (selectedVoice) => {
//     setAudioVoice(selectedVoice.name);
//     setSelectedVoiceUrl(selectedVoice.url);
//   };

//   return (
//     <Box sx={{ p: 2 }}>
//       <Typography variant="h6" gutterBottom style={{ fontSize: '16px', fontWeight: '500', width: '143px', height: '20px', marginBottom: '20px' }}>
//         Select Voice
//       </Typography>
//       <Grid container spacing={1} justifyContent="start">
//         {Array.isArray(voices) && voices.map((voiceOption) => (
//           <Grid item key={voiceOption.id}>
//             <Button
//               variant="outlined"
//               onClick={() => handleVoiceSelect(voiceOption)}
//               sx={{
//                 width: 'auto',
//                 backgroundColor: audioVoice === voiceOption.name ? '#3a3f69' : '#30355f',
//                 color: theme === 'dark' ? 'white' : 'black',
//                 '&:hover': {
//                   backgroundColor: audioVoice === voiceOption.name ? '#3a3f69' : '',
//                 },
//                 borderColor: audioVoice === voiceOption.name ? '#cac4d0' : 'transparent',
//                 mx: 0.5, // Add horizontal margin for spacing
//               }}
//             >
//               {voiceOption.name}
//             </Button>
//           </Grid>
//         ))}
//       </Grid>
//       {selectedVoiceUrl && (
//         <Box sx={{ mt: 2 }}>
//           <Typography variant="subtitle1">Audio Preview:</Typography>
//           <audio controls src={selectedVoiceUrl} >
//             Your browser does not support the audio element.
//           </audio>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default VoiceSettings;


import React, { useState, useEffect } from "react";
import { Box, Button, Grid, Typography, IconButton } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";
import sourceUrl from "../../../../api/Source.api";

const VoiceSettings = () => {
  const { audioVoice, setAudioVoice } = useWorkspace();
  const [voices, setVoices] = useState([]);
  const [playingVoice, setPlayingVoice] = useState(null);
  const [audioElement, setAudioElement] = useState(null);
  const theme = localStorage.getItem('theme');
  const token = localStorage.getItem('token');

  const fetchVoices = async () => {
    try {
      const response = await fetch(`${sourceUrl}/audio/voice`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      });
      const data = await response.json();
      console.log('Fetched voices:', data.data.data); // Log the response for debugging
      setVoices(data.data.data);
      if (data.data.data.length > 0 && !audioVoice) {
        // Set default selected voice if none is selected yet
        setAudioVoice(data.data.data[0].name);
      }
    } catch (error) {
      console.error('Error fetching voices:', error);
    }
  };

  useEffect(() => {
    fetchVoices();
    // Cleanup audio element when the component unmounts
    return () => {
      if (audioElement) {
        audioElement.pause();
        setAudioElement(null);
      }
    };
  }, []);

  const handleVoiceSelect = (selectedVoice) => {
    setAudioVoice(selectedVoice.name);
    if (playingVoice === selectedVoice.id) {
      audioElement.pause();
      setPlayingVoice(null);
    } else {
      if (audioElement) {
        audioElement.pause();
      }
      const newAudioElement = new Audio(selectedVoice.url);
      newAudioElement.play();
      setPlayingVoice(selectedVoice.id);
      setAudioElement(newAudioElement);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom style={{ fontSize: '16px', fontWeight: '500', width: '143px', height: '20px', marginBottom: '20px' }}>
        Select Voice
      </Typography>
      <Grid container spacing={1} justifyContent="start">
        {Array.isArray(voices) && voices.map((voiceOption) => (
          <Grid item key={voiceOption.id} xs={12}>
            <Grid container alignItems="center" gap={'20px'}>
              <Grid item>
                <IconButton
                  onClick={() => handleVoiceSelect(voiceOption)}
                  sx={{
                    color: playingVoice === voiceOption.id ? '#ffffff' : '#9e9e9e', // Custom icon color
                    backgroundColor: playingVoice === voiceOption.id ? '#3a3f69' : '#30355f',
                    '&:hover': {
                      backgroundColor: '#3a3f69', // Background color on hover
                    },
                  }}
                >
                  {playingVoice === voiceOption.id ? <PauseIcon /> : <PlayArrowIcon />}
                </IconButton>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  onClick={() => setAudioVoice(voiceOption.name)}
                  sx={{
                    width: 'auto',
                    backgroundColor: audioVoice === voiceOption.name ? '#3a3f69' : '#30355f',
                    color: theme === 'dark' ? 'white' : 'black',
                    '&:hover': {
                      backgroundColor: audioVoice === voiceOption.name ? '#3a3f69' : '',
                    },
                    borderColor: audioVoice === voiceOption.name ? '#cac4d0' : 'transparent',
                    mx: 0.5, // Add horizontal margin for spacing
                    textTransform:'none'
                  }}
                >
                  {voiceOption.name}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default VoiceSettings;




